export const BASE_API_URL = () => {
  return 'https://api.dev.readysetvr.com/api/1';
};
